import SelectStyled from "@/components/SelectStyled";
import { MenuItem } from "@mui/material";

export default function YearPicker({
  name,
  label,
  hint,
  onChange,
  value,
  defaultValue,
  required = false,
  placeholder,
  allowEmpty = false
}) {
  const handleInputChanged = (event, value = null) => {
    if (onChange) {
      onChange(event, value);
    }
  };

  const years = () => {
    let allYears = [];
    for (let y = 1950; y <= new Date().getFullYear(); y++) {
      allYears = [y, ...allYears];
    }

    return allYears;
  };

  return (
    <SelectStyled
      name={name}
      label={label}
      hint={hint}
      onChange={handleInputChanged}
      required={required}
      value={value}
      defaultValue={defaultValue}
      menuProps="LimitHeight"
      placeholder={placeholder}
      allowEmpty={allowEmpty}
    >
      {years().map((option, key) => (
        <MenuItem value={option} key={key}>
          {option}
        </MenuItem>
      ))}
    </SelectStyled>
  );
}
